import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceUnavalaibleComponent } from './default-pages/error/service-unavalaible.component';


const routes: Routes = [
  { path: "home", loadChildren: () => import('./main/main.module').then(m => m.MainModule) },
  { path: 'service-unavalaible', component: ServiceUnavalaibleComponent ,pathMatch: 'full' },
  { path: '', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
